import React, { useEffect, useMemo } from "react"
import { useState } from "react"
import { MARKETPLACE } from "@acc/shared"
import BaseApi from "../../api/api"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import s from "./StorageManager.module.css"
import { useAppSelector } from "../../app/hooks"
import { selectOrdersStore } from "../../app/reducers/ordersReducer"
import { Button } from "@radix-ui/themes"
import { Select } from "../Select/Select"
import { MultiSelect } from "../Select/MultiSelect"

export const StorageManager = () => {
  const [marketPlace, setMarketPlace] = useState<MARKETPLACE>(MARKETPLACE.WB)
  const storageData = useAppSelector(selectOrdersStore)
  const [selectedStorages, setSelectedStorages] = useState<string[]>([])
  const storages = useMemo(() => {
    switch (marketPlace) {
      case MARKETPLACE.WB:
        return storageData.storages.map((storage) => ({
          name: storage.name,
          id: storage.id,
          isHidden: !!storage.isHidden,
        }))
      case MARKETPLACE.YANDEX:
        return storageData.yandexCampaigns.map((storage) => ({
          name: storage.domain,
          id: storage.id,
          isHidden: !!storage.isHidden,
        }))
      case MARKETPLACE.OZON:
        return storageData.ozonStorages.map((storage) => ({
          name: storage.name,
          id: storage.warehouse_id,
          isHidden: !!storage.isHidden,
        }))
      default:
        return []
    }
  }, [marketPlace, storageData])

  const applyChanges = () => {
    // selectedStorages хранит строковые ключи; бэкенду отдаём оригинальные id.
    const hiddenStorageIds = storages
      .filter((el) => !selectedStorages.includes(String(el.id)))
      .map((el) => el.id)
    BaseApi.changeStorages(marketPlace, { hiddenStorageIds }).then((res) => {
      NotificationService.showNotification({
        message: res.data.message,
        level: res.data.success ? "success" : "error",
      })
    })
  }

  useEffect(() => {
    setSelectedStorages(
      storages.filter((el) => !el.isHidden).map((el) => String(el.id)),
    )
  }, [storages])

  const updateStorages = async () => {
    try {
      await BaseApi.updateStorages(marketPlace)
      NotificationService.showNotification({
        message: "Склады успешно обновлены",
        level: "success",
      })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div>
      <div className={s.container}>
        <Select
          label="Выберите маркетплейс:"
          value={marketPlace || ""}
          onChange={(value) => setMarketPlace(value as MARKETPLACE)}
          options={Object.values(MARKETPLACE).map((shopName) => ({
            value: shopName,
            label: shopName,
          }))}
          placeholder="Выберите маркетплейс"
        />
        <Button disabled={!marketPlace} onClick={updateStorages}>
          обновить склады
        </Button>
      </div>
      <div className={s.container}>
        <MultiSelect
          label="Выберите видимые склады:"
          options={storages.map((storage) => ({
            value: String(storage.id),
            label: storage.name,
          }))}
          values={selectedStorages}
          onChange={setSelectedStorages}
          style={{ flex: "1" }}
          placeholder={
            storages.length ? "Все склады скрыты" : "Нет доступных складов"
          }
        />
        <Button disabled={!marketPlace} onClick={applyChanges}>
          Применить
        </Button>
      </div>
    </div>
  )
}
